export default __webpack_public_path__ + "static/media/robot.f3e47d4d.svg";